export const convertBalanceToNum = val => {
  const withoutPoint = val.toString().replace(/\./g, '');
  const semiNumber = withoutPoint.replace(',', '.');
  return Number(semiNumber);
};
